import React from 'react';
import { Button } from 'react-bootstrap';

import { useTranslation } from '../../../common/hooks/useTranslation';

interface SurveyQuestionsControlsProps {
  onAdd: () => void;
  onSave: () => void;
  isLocked?: boolean;
}

export const SurveyQuestionsControls: React.FC<
  SurveyQuestionsControlsProps
> = ({ onAdd, onSave, isLocked }) => {
  const { t, tk } = useTranslation('administrationLng');

  return (
    <div className="d-flex gap-2 justify-content-between">
      <Button variant="outline-primary" onClick={onAdd} disabled={isLocked}>
        {t(tk.survey.questionAdd)}
      </Button>
      <Button variant="primary" onClick={onSave} disabled={isLocked}>
        {t(tk.button.save)}
      </Button>
    </div>
  );
};
